import { AfterContentInit, Component, ElementRef, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
	selector: "app-missing-input",
	templateUrl: "./missing-input.component.html",
	styleUrls: ["./missing-input.component.scss"],
})
export class MissingInputComponent implements AfterContentInit, OnChanges {
	@Input() show = false;

	constructor(private host: ElementRef) {}

	ngAfterContentInit() {
		this.updateErrorClass();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes["show"]) {
			this.updateErrorClass();
		}
	}

	private updateErrorClass() {
		const errorElements: NodeListOf<HTMLElement> = this.host.nativeElement.querySelectorAll(".want-error-border");

		errorElements.forEach(el => {
			if (this.show) {
				el.classList.add("has-error");
			} else {
				el.classList.remove("has-error");
			}
		});
	}
}
